import type { ProspectListRead } from '@signalvote/shared';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { ProspectListProgressLine } from './ProspectListProgressLine';
import { ProspectListRetry } from './ProspectListRetry';
import { ProspectListUndo } from './ProspectListUndo';

/**
 * The campaign's earlier uploads, newest first: where each stands, with Undo, and Retry for one that
 * failed partway.
 */
export function PastUploads({
  open,
  onOpenChange,
  lists,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  lists: ProspectListRead[];
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[85vh] max-w-xl overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Past uploads</DialogTitle>
          <DialogDescription>Undo a list to take its people back off your book.</DialogDescription>
        </DialogHeader>
        {lists.length === 0 ? (
          <p className="text-sm text-muted-foreground">Nothing uploaded yet.</p>
        ) : (
          <ul className="divide-y">
            {lists.map((list) => (
              <li key={list.id} className="flex items-start justify-between gap-3 py-3 text-sm">
                <div className="min-w-0">
                  <p className="font-medium text-foreground">{list.name}</p>
                  <ProspectListProgressLine list={list} />
                </div>
                <div className="flex shrink-0 items-start gap-2">
                  <ProspectListRetry list={list} />
                  <ProspectListUndo list={list} />
                </div>
              </li>
            ))}
          </ul>
        )}
      </DialogContent>
    </Dialog>
  );
}
